import { Band, Eyebrow, BandCta, displayFont } from "./band-helpers";

export function FinalCtaBand() {
  return (
    <Band
      className="relative overflow-hidden storefront-surface-dark-alt py-16 sm:py-20 lg:py-24"
    >
      <div className="relative grid gap-10 lg:grid-cols-[1.2fr_0.8fr] lg:items-center">
        <div className="space-y-6">
          <Eyebrow inverse>Ready when you are</Eyebrow>
          <h2
            className={`${displayFont.className} text-[clamp(1.85rem,3.6vw,3.2rem)] font-bold leading-[1.06] tracking-tight text-white`}
          >
            Skip the cooking tonight. Let us bring Lagos to your table.
          </h2>
          <p className="max-w-xl text-lg leading-8 text-white/65">
            Browse the full menu, pick your favourites, and choose collection
            or delivery. Every dish is made fresh and ready when you are.
          </p>
          <div className="flex flex-wrap gap-4">
            <BandCta href="/menu" label="Open the menu" />
            <BandCta
              href="/menu/rice-meals"
              label="Start with rice meals"
              tone="ghost"
            />
          </div>
        </div>

        <div className="rounded-[1.6rem] border border-white/10 bg-white/6 p-6 backdrop-blur-sm sm:p-8">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#9cd4a0]">
            Order today
          </p>
          <ul className="mt-5 space-y-3" role="list">
            {[
              "Same-day collection until 8:30 PM",
              "Delivery available across 12 London boroughs",
              "Family feasts from GBP 49",
              "Order by 4 PM for same-day delivery",
            ].map((line) => (
              <li
                key={line}
                className="flex items-start gap-3 text-sm leading-6 text-white/80"
              >
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#4ade80]" />
                <span>{line}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Band>
  );
}
